import * as React from 'react';
import { PluginTemplates } from "../utils/PluginTemplates";
import FalconHeader from "../components/navigation/FalconHeader";
import FalconFooter from "../components/navigation/FalconFooter";
import {FalconNavigatorHeader, resourcesHelper} from "@falcon/services";

export class ContactUsPage extends React.Component {

    private pluginTemplates = new PluginTemplates();

    public componentDidMount(): void {
        this.pluginTemplates.setPageTitle("Contact Us");
    }

    public render() {
        return (
            <React.Fragment>
                <FalconHeader/>

                <div className="plugin">
                    <FalconNavigatorHeader back="/dashboard" title="Contact us"/>
                    <div className="panel inner-container">
                        <p>For any questions about your {resourcesHelper.THEME} subscription or if you want to request paper documents, email our customer service team.</p>
                        <div className="email-icon-item"/>
                        <a className="contact-email-link long-word" href="mailto:customerrelations_flow@lv.co.uk" target="_blank" id="glCustomerSupport"
                           aria-label="Flow customer relations email address">customerrelations_flow@lv.co.uk</a>
                    </div>
                    {this.pluginTemplates.renderBackLink("Back", false, "/dashboard")}
                </div>

                <FalconFooter/>
            </React.Fragment>
        )
    }
}
